import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Also what makes the two native date inputs in the filter bar render dark:
    // <input type="date"> is drawn by the browser and only follows color-scheme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  header: {
    display: 'flex',
    paddingBottom: '20px',
  },
  title: {
    flexGrow: 1,
    letterSpacing: '-0.5px',
  },
  locationName: {
    // '#22617B' is exactly `primary.mainBlue`, which already has a dark value.
    color: theme.palette.primary.mainBlue,
    paddingLeft: '1%',
    fontWeight: 'bold',
    marginLeft: '10px',
  },
  tableHeader: {
    textAlign: 'center',
  },
  taskNameHeader: {
    textAlign: 'left',
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  tag: {
    borderRadius: '5px',
    padding: '5px 8px',
    maxWidth: '160px',
    margin: '0px auto',
  },
  iconButton: {
    backgroundColor: theme.palette.custom.solidButtonBackground,
    borderRadius: '10px',
    color: theme.palette.custom.solidButtonText,
    marginLeft: '16px',
    padding: '8px',

    '&:hover': {
      backgroundColor: `${theme.palette.custom.solidButtonHoverBackground} !important`,
    },
  },
  // PRECIO deshabilitado en amarillo mientras el análisis IA está pendiente.
  iconButtonAiPending: {
    '&.Mui-disabled': {
      color: theme.palette.custom.statusWarningText,
      backgroundColor: theme.palette.custom.statusWarningBackground,
    },
  },
  // Every pair below maps to the semantic status tokens with the SAME light
  // values the `secondary.*` keys had. Those keys are inherited verbatim from the
  // light palette in dark mode, so the fills stayed pastel on a dark surface.
  tagOpen: {
    color: theme.palette.custom.statusOpenText,
    backgroundColor: theme.palette.custom.statusOpenBackground,
  },
  tagWaitinfForApproval: {
    color: theme.palette.custom.statusClosedText,
    backgroundColor: theme.palette.custom.statusClosedBackground,
  },
  tagApproved: {
    color: theme.palette.custom.statusApprovedText,
    backgroundColor: theme.palette.custom.statusApprovedBackground,
  },
  tagProcessing: {
    color: theme.palette.custom.statusNeutralText,
    backgroundColor: theme.palette.custom.statusNeutralBackground,
  },
  tagClose: {
    color: theme.palette.custom.statusRejectedText,
    backgroundColor: theme.palette.custom.statusRejectedBackground,
  },
  tagRejected: {
    color: theme.palette.custom.statusPendingText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  tagPendingDate: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
  tagNA: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  filterText: {
    marginBottom: '8px',
    width: '100%',
  },
  applyFilterButton: {
    height: 40,
    marginBottom: 16,
  },
  cleanFiltersButton: {
    height: 40,
    marginLeft: 8,
    marginBottom: 16,
    // '#d32f2f' is exactly MUI's `error.dark`.
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.custom.solidButtonText,
  },
  inputLabel: {
    // Masks the outlined-Select notch, so it has to match the page behind it.
    backgroundColor: theme.palette.custom.pageBackground,
    padding: '0 4px',
    borderRadius: '4px',
    zIndex: 1,
  },
  taskResponseTable: {
    width: '100%',
    '@media (max-width:1270px)': {
      width: '900px',
    },
    '@media (max-width:1170px)': {
      width: '870px',
    },
    '@media (max-width:1130px)': {
      width: '800px',
    },
    '@media (max-width:1080px)': {
      width: '750px',
    },
  },
  tooltipContent: {
    fontSize: '1rem !important',
    backgroundColor: `${theme.palette.custom.brandTooltipBackground} !important`,
    color: `${theme.palette.custom.tooltipText} !important`,
    fontweight: '500',
  },
}));

export default useStyles;
